import React from 'react'
import { Container, SecurityBarContainer } from './styles'

export enum SecurityBarStatus {
    weak = 'weak',
    medium = 'medium',
    strong = 'strong',
}

export interface SecurityBarProps {
    status?: SecurityBarStatus
    styles: {}
}

const securityBarStatus = {
    weak: {
        securityLevel: 'Fraca',
        securityBarBackgroundColor: ['#DA3347', '#363636', '#363636'],
    },
    medium: {
        securityLevel: 'Média',
        securityBarBackgroundColor: ['#D1B287', '#D1B287', '#363636'],
    },
    strong: {
        securityLevel: 'Forte',
        securityBarBackgroundColor: ['#2DA853', '#2DA853', '#2DA853'],
    },
}

export const SecurityBar = ({ status, styles }: SecurityBarProps) => {
    if (status !== undefined) {
        return (
            <Container style={styles}>
                <span className="strong-bar-text">
                    Nível de segurança: <strong>{securityBarStatus[status].securityLevel}</strong>
                </span>

                <SecurityBarContainer>
                    <div style={{ backgroundColor: securityBarStatus[status].securityBarBackgroundColor[0] }} />
                    <div style={{ backgroundColor: securityBarStatus[status].securityBarBackgroundColor[1] }} />
                    <div style={{ backgroundColor: securityBarStatus[status].securityBarBackgroundColor[2] }} />
                </SecurityBarContainer>
            </Container>
        )
    }

    return (
        <Container style={styles}>
            <span className="strong-bar-text">
                Nível de segurança: <strong />
            </span>

            <SecurityBarContainer color="red">
                <div style={{ backgroundColor: '#363636' }} />
                <div style={{ backgroundColor: '#363636' }} />
                <div style={{ backgroundColor: '#363636' }} />
            </SecurityBarContainer>
        </Container>
    )
}
